import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { SettingsAdmin } from "@/pages/admin/SettingsAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/settings",
  component: () => (
    <RoleGuard action="system_settings_edit">
      <SettingsAdmin />
    </RoleGuard>
  ),
});
